module.exports = __webpack_public_path__ + "img/jgbg.e2f93886.png";